var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 20",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-325,-175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-lock",
    transform: "matrix(1.66667,0,0,1.66667,-216.097,-116.667)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 325,
    y: 175,
    width: 12,
    height: 12,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20746,0,0,1.20746,-68.1302,-38.7278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.503,181.262C327.494,180.973 327.503,180.713 327.503,180.5C327.503,178.846 328.846,177.503 330.5,177.503C332.154,177.503 333.497,178.846 333.497,180.5C333.497,180.713 333.506,180.973 333.497,181.262L332.503,181.262C332.512,180.971 332.503,180.71 332.503,180.5C332.503,179.394 331.606,178.497 330.5,178.497C329.394,178.497 328.497,179.394 328.497,180.5C328.497,180.71 328.488,180.971 328.497,181.262L327.503,181.262Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.10513,0,0,1.42054,-35.1787,-77.7455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.569,181.798L335.569,185.202C335.569,185.643 335.11,186 334.544,186L328.025,186C327.459,186 327,185.643 327,185.202L327,181.798C327,181.357 327.459,181 328.025,181L334.544,181C335.11,181 335.569,181.357 335.569,181.798ZM330.8,183.956L330.8,185.089L331.886,185.089L331.886,183.92C332.401,183.741 332.76,183.338 332.76,182.871C332.76,182.238 332.099,181.723 331.285,181.723C330.47,181.723 329.809,182.238 329.809,182.871C329.809,183.373 330.224,183.8 330.8,183.956Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.f572295e08062ee9ac98aaec6fafca7e.svg";
export { ForwardRef as ReactComponent };